<template>
  <div id="app">
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh" class="container"> -->
      <!-- <router-view v-if="isRouterAlive"></router-view> -->
      <div class="container">
        <keep-alive>
            <router-view v-if="isRouterAlive&&$route.meta.keepAlive"></router-view>
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive&&isRouterAlive"></router-view>
        <loading></loading>
      </div>
    <!-- </van-pull-refresh> -->
  </div>
</template>

<script>
import loading from "@/components/loading"
import {Toast} from 'vant';

export default {
  name: 'App',
  components: {
    loading
  },
  data(){
    return{
      isPhone:false,
      isLoading: false,
      isRouterAlive:true,
      previous2Page:'',
      previous2QueryData:{},
      previousPage:'',
      previousQueryData:{},
      currentPage:'',
      currentQueryData:{},
      _href:'',
      keepAliveList:{
        'main':0,
        'part':0,
        'employee':0,
        'deallist':0,
        'dealOrder':0,
        'partOrder':0,
        'morelist':0,
        'finishedSurface':0,
        'finishedSurface2':0,
        'myOrder':0,
        'log':0,
        'ncomp':0,
        'lastPrice':0,
        'GYSProduct':0
      }
    }
  },
  watch:{
    $route(to,from){
      let _this = this;
      if(this.keepAliveList[from.name]||this.keepAliveList[from.name]===0){
        if(document.querySelector('body').scrollTop){
          this.keepAliveList[from.name] = document.querySelector('body').scrollTop
          _this.isPhone = true;
        }else if(document.querySelector('html').scrollTop){
          this.keepAliveList[from.name] = document.querySelector('html').scrollTop
          _this.isPhone = false;
        }else{
          document.querySelector('html').scrollTop = 0
        }
      }
      if(this.keepAliveList[to.name]){
        console.log('跳转到新页面，新页面：'+this.keepAliveList[to.name]);
        this.$nextTick(() => {
          if(this.isPhone){
            document.querySelector('body').scrollTop = _this.keepAliveList[to.name];
          }else{
            document.querySelector('html').scrollTop = _this.keepAliveList[to.name];
          }
        });
      }else{
        document.querySelector('body').scrollTop = 0;
        document.querySelector('html').scrollTop = 0;
      }
    }
    // $route(to,from){
      
    //   this.currentPage = to.name;
    //   this.currentQueryData = JSON.stringify(to.query);

    //   this.previous2Page = this.previousPage?this.previousPage:'';
    //   this.previous2QueryData = this.previousQueryData

    //   this.previousPage = from.name;
    //   this.previousQueryData = JSON.stringify(from.query);
      

    //   let _this = this;
    //   if(this.keepAliveList[from.name]||this.keepAliveList[from.name]===0){
    //     this.keepAliveList[from.name] = document.querySelector('.container').scrollTop
    //   }
    //   if(this.keepAliveList[to.name]){
    //     console.log('跳转到新页面，新页面：'+this.keepAliveList[to.name]);
    //     this.$nextTick(() => {
    //       console.log(_this.currentQueryData);
    //       console.log(_this.previous2QueryData);
    //       if(_this.currentQueryData == _this.previous2QueryData){
    //         console.log('不需要刷新');
    //         document.querySelector('.container').scrollTop = _this.keepAliveList[to.name];
    //       }else{
    //         console.log('需要刷新1111');
    //         document.querySelector('.container').scrollTop = 0;
    //         _this.onRefresh();
    //       }
    //     });
    //   }else{
    //     console.log('需要刷新2222');
    //     _this.onRefresh();
    //     document.querySelector('.container').scrollTop = 0;
    //   }
    // }
  },
  created () {
    document.querySelector('head').addEventListener('click',function(){
        document.querySelector('.container').scrollTop = 0;
    })

    //在页面加载时读取localStorage里的状态信息
    if (localStorage.getItem("store") ) {
        this.$store.replaceState(Object.assign({}, this.$store.state,JSON.parse(localStorage.getItem("store"))))
    } 
    // if(localStorage.getItem('userInfo')){
    //   store.dispatch('global/setUserInfo', JSON.parse(localStorage.getItem('userInfo')));
    // }
    //在页面刷新时将vuex里的信息保存到localStorage里
    window.addEventListener("beforeunload",()=>{
        localStorage.setItem("store",JSON.stringify(this.$store.state))
    })
  },
  methods:{
    onRefresh(){
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
          this.isRouterAlive = true;         //再打开
      }) 
      // Toast({
      //     message: '刷新成功',
      //     duration: 1000
      // });
      this.isLoading = false;
    },
    
  }
}
</script>

<style lang="scss" scoped>
@import "./assets/css/reset.css";
@import "./assets/css/vantReset.css";
#app{
  min-height: 100%;
  .container{
    min-height: 100%;
    // overflow: scroll;
    /deep/.van-pull-refresh__head{
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 26px !important;
        .van-loading__spinner{
          font-size: 26px !important;
          
        }
    }
  }
}
body,html,#app{
  height: 100%;
  // background-color: #f2f2f2;
}
#app{
  -webkit-text-size-adjust: 100% ;
}
.container{
  min-height: 100%;
}
</style>
